import { useDrop } from 'react-dnd'
import { ItemTypes } from 'data/constants'
import React from 'react'
import { archiveNotes } from '../../../../../data/notes/actions'
import { useDispatch } from 'react-redux'
import { NoteDragItem } from '../Note/useNoteDragAndDrop'

export const useArchivedDrop = (
  filterId: string,
  ref: React.RefObject<any>
) => {
  const dispatch = useDispatch()

  const [{ isDragOver }, drop] = useDrop<
    NoteDragItem,
    void,
    { isDragOver: boolean }
  >({
    accept: ItemTypes.NOTE,

    collect(monitor) {
      return {
        isDragOver: monitor.isOver({ shallow: true }),
      }
    },

    drop(dragItem) {
      dispatch(archiveNotes({ noteIds: [dragItem.noteId] }))
    },
  })

  drop(ref)

  return isDragOver
}
